import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Fund',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Fund',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Fund',
    column_type: 'datetime',
  },
  closed_period: {
    model_name: 'Fund',
    column_type: 'string',
  },
  code: {
    model_name: 'Fund',
    column_type: 'string',
  },
  custodian: {
    model_name: 'Fund',
    column_type: 'string',
  },
  early_warning: {
    model_name: 'Fund',
    column_type: 'string',
  },
  name: {
    model_name: 'Fund',
    column_type: 'string',
  },
  short_name: {
    model_name: 'Fund',
    column_type: 'string',
  },
  total_scale: {
    model_name: 'Fund',
    column_type: 'string',
  },
  risk_level: {
    model_name: 'Fund',
    column_type: 'enum',
  },
  visibility: {
    model_name: 'Fund',
    column_type: 'enum',
  },
  setup_date: {
    model_name: 'Fund',
    column_type: 'date',
  },
  is_index: {
    model_name: 'Fund',
    column_type: 'boolean',
  },
  allot_trade_rule: {
    model_name: 'Fund',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'allot_trade_rule',
      model_name: 'TradeRule',
      foreign_key: 'allot_trade_rule_id',
    },
  },
  allot_trade_rule_id: {
    model_name: 'Fund',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'allot_trade_rule',
      model_name: 'TradeRule',
      foreign_key: 'allot_trade_rule_id',
    },
  },
  redeem_trade_rule: {
    model_name: 'Fund',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'redeem_trade_rule',
      model_name: 'TradeRule',
      foreign_key: 'redeem_trade_rule_id',
    },
  },
  redeem_trade_rule_id: {
    model_name: 'Fund',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'redeem_trade_rule',
      model_name: 'TradeRule',
      foreign_key: 'redeem_trade_rule_id',
    },
  },
  fee_rate: {
    model_name: 'Fund',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'fee_rate',
      model_name: 'FeeRate',
      foreign_key: 'fund_id',
    },
  },
  fund_id: {
    model_name: 'Fund',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'latest_fund_value',
      model_name: 'FundValue',
      foreign_key: 'fund_id',
    },
  },
  management: {
    model_name: 'Fund',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'management',
      model_name: 'Management',
      foreign_key: 'fund_id',
    },
  },
  allot_process: {
    model_name: 'Fund',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  revenue_datum: {
    model_name: 'Fund',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'revenue_datum',
      model_name: 'RevenueDatum',
      foreign_key: 'owner_id',
    },
  },
  owner_id: {
    model_name: 'Fund',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'revenue_datum',
      model_name: 'RevenueDatum',
      foreign_key: 'owner_id',
    },
  },
  latest_fund_value: {
    model_name: 'Fund',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'latest_fund_value',
      model_name: 'FundValue',
      foreign_key: 'fund_id',
    },
  },
  holders_count: {
    model_name: 'Fund',
    column_type: 'string',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
